import { render, staticRenderFns } from "./ReviewLinkGenerator.vue?vue&type=template&id=7b8b9c94"
import script from "./ReviewLinkGenerator.vue?vue&type=script&lang=js"
export * from "./ReviewLinkGenerator.vue?vue&type=script&lang=js"
import style0 from "./ReviewLinkGenerator.vue?vue&type=style&index=0&id=7b8b9c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports